import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import React, { useEffect, useState } from "react";
import { HorizontalStack } from "../../styles/Containers";
import DateFnsUtils from '@date-io/date-fns';
import { StyledDatePickerPretty, StyledTextField } from "../../styles/matieralui/Form";
import { StyledP } from "../../styles/StyledHTML";
import { StyledButton } from '../../styles/matieralui/Button';
import { LocalConvenienceStoreOutlined } from '@mui/icons-material';
import moment from 'moment';


export const DateRange = ({ value, onChange }) => {


    const handleStartDate = (v) => {
        const x = { ...value };
        x.start = formatDate(v);
        onChange(x);
    }

    const formatDate = (v) => {
        if (v === null) return '';
        else return moment(v).format('YYYY-MM-DD HH:mm:ss.SSS')
    }


    const handleEndDate = (v) => {
        const x = { ...value };
        x.end = formatDate(v);
        onChange(x);
    }

    const clearDate = () => {
        onChange(null)
    }



    return (
        <HorizontalStack flex aling="center" minWidth="300px">
            <LocalizationProvider dateAdapter={DateFnsUtils}>
                <HorizontalStack flex align="center">
                    <StyledDatePickerPretty
                        label="Start"
                        type="date"
                        value={(value?.start) ? value.start : null}
                        onChange={date => handleStartDate(date)}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        renderInput={(startProps) =>
                            <StyledTextField {...startProps}
                            />}
                    />
                    <StyledP>to</StyledP>
                    <StyledDatePickerPretty
                        label="End"
                        type="date"
                        value={(value?.end) ? value.end : null}
                        onChange={date => handleEndDate(date)}
                        renderInput={(endProps) => <StyledTextField {...endProps} />}
                    />
                </HorizontalStack>
                {(value?.start != null || value?.end != null) ? <StyledButton onClick={() => clearDate()}>Clear</StyledButton> : <div />}
            </LocalizationProvider>
        </HorizontalStack>
    )
}
